import React from 'react';
import './ClientsSection.css';
import dropbox from '../assets/client1.png';

const defaultClients = [
  { img: dropbox, alt: 'Dropbox', label: 'Dropbox' },
  { img: dropbox, alt: 'Dribbble', label: 'dribbble' },
  { img: dropbox, alt: 'Dropbox', label: 'Dropbox' },
  { img: dropbox, alt: 'Atlassian', label: 'ATLASSIAN' },
  { img: dropbox, alt: 'Dropbox', label: 'Dropbox' },
  { img: dropbox, alt: 'Coinbase', label: 'coinbase' },
];

const ClientsSection = ({ clients = defaultClients }) => (
  <section className="clients-section container">
    <h2 className="clients-title">Our Clients</h2>
    <div className="clients-subtitle">
      Trusted By Car Owners, Dealers & Auto Enthusiasts Nationwide
    </div>
    <div className="clients-logos">
      {clients.map((c, i) => (
        <div className="client-logo-wrap" key={i}>
          <img src={c.img} alt={c.alt} className="client-logo-img" />
        </div>
      ))}
    </div>
  </section>
);

export default ClientsSection; 